import type { ComponentSingleStyleConfig } from '@chakra-ui/theme'

import { primaryColor } from '../foundations/primaryColor'

// You can also use the more specific type for
// a single part component: ComponentSingleStyleConfig
export const Text: ComponentSingleStyleConfig = {
  // The styles all teext have in common
  baseStyle: {
    color: primaryColor.text.bgColorText // <-- color is same for all variants
  },
  // variants
  variants: {
    BTN: { fontWeight: '600', fontSize: '14px', lineHeight: '20px' },
    LG: { fontWeight: 'normal', fontSize: '20px', lineHeight: '24px' },
    MD: { fontWeight: 'normal', fontSize: '16px', lineHeight: '20px' },
    SM: { fontWeight: 'normal', fontSize: '13px', lineHeight: '16px' },
    XS: { fontWeight: 'normal', fontSize: '12px', lineHeight: '15px' },
    LG_SB: { fontWeight: 'semibold', fontSize: '20px', lineHeight: '24px' },
    MD_SB: { fontWeight: 'semibold', fontSize: '16px', lineHeight: '20px' },
    SM_SB: { fontWeight: 'semibold', fontSize: '13px', lineHeight: '16px' },
    XS_SB: { fontWeight: 'semibold', fontSize: '12px', lineHeight: '15px' },
  },
  // The default variant values
  defaultProps: {
    variant: 'MD',
  },
}
